// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__LHCiq","round":"Avatar_round__+xxdq","noImage":"Avatar_noImage__SFOb6"};